<template>
    <div class="app-main" id="AppMain">
        <div class="app-main-wrap">
            <transition name="fade-transform" mode="out-in">
                <keep-alive>
                    <router-view :key="key" />
                </keep-alive>
            </transition>
        </div>
        <Footer></Footer>
    </div>
</template>

<script>
import Footer from './Footer.vue'
export default {
    name: 'AppMain',
    components: { Footer },
    computed: {
        key() {
            return this.$route.path
        }
    }
}
</script>

<style lang="scss" scoped>

::v-deep .app-main::-webkit-scrollbar {
  display: none;
  width: 0;
  height: 0;
}

.app-main {
    scrollbar-width: none; /* Firefox 隐藏滚动条 */
    -ms-overflow-style: none; /* IE/Edge 隐藏滚动条 */
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    overflow: auto;
    background-image: var(--theme-page-bg);
    background-size: var(--theme-page-bg-size);
    background-position: var(--theme-page-bg-position);

    .app-main-wrap {
        margin: 0;
        padding-left: 14px;
        padding-right: 14px;
        width: 100%;
        box-sizing: border-box;
    }
}

</style>
